var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zxBadge"},[(_vm.sum != 0)?_c('sup',{staticClass:"badge red",class:[_vm.bgwidth, { dot: _vm.isDot }]},[_vm._v(_vm._s(_vm.isDot ? '' : _vm.sum))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6002dbde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Badge.vue
// module id = null
// module chunks = 